import { Topbar } from '../../components/Topbar/Topbar';
import { Badge, Container, ListGroup, ProgressBar } from 'react-bootstrap';
import { Footer } from '../../components/Footer/Footer';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { Fragment, useEffect, useState } from 'react';
import { UserUID } from '../../components/UserUID/UserUID';
import { formatSecondsTimestamp } from '../../utils/utils';
import { Copyable } from '../../components/Copyable/Copyable';
import { Title } from '../../components/Title/Title';
import styles from './Feedbacks.module.scss';

const FeedbacksComponent = () => {
  const { getFeedbacks } = useFirebase();

  const [loading, setLoading] = useState(false);
  const [feedbacks, setFeedbacks] = useState([]);
  const [averages, setAverages] = useState<[string, number][]>([]);

  useEffect(() => {
    setLoading(true);
    getFeedbacks()
      .then(({ feedbacks }) => setFeedbacks(feedbacks))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    const allQuestions = new Map<string, number[]>();
    for (const feedback of feedbacks) {
      for (let i = 0; i < feedback.questions.length; i++) {
        const question = feedback.questions[i];
        const rating = feedback.ratings[i];
        if (!allQuestions.has(question)) allQuestions.set(question, []);
        allQuestions.set(question, [...allQuestions.get(question), rating]);
      }
    }
    const averagesObj: { [p: string]: number } = {};
    for (const [question, ratings] of allQuestions.entries() as any) {
      averagesObj[question] = parseFloat((ratings.reduce((acc, val) => acc + val) / ratings.length).toFixed(1));
    }
    const averages = Object.entries(averagesObj).sort(([, a], [, b]) => b - a);
    setAverages(averages);
  }, [feedbacks]);

  return (
    <>
      <Title>Feedbacks</Title>

      <Topbar />

      <Container className={'my-5'}>
        <div className={'d-flex align-items-center'}>
          <div className={'display-4'}>Feedbacks</div>
        </div>
        <ListGroup className={'mt-4'}>
          {loading && <div className={'text-center'}>Caricamento in corso...</div>}

          {!loading && !feedbacks.length && <div className={'text-center'}>Nessun feedback.</div>}

          {!loading && (
            <>
                <div className={styles.averagesWrapper}>
                <div className={'h5 px-4 mt-2'}>Media delle valutazioni</div>
                {averages.map(([question, rating]) => (
                  <div key={question} className={'d-flex align-items-center px-4 my-1'}>
                    <div className={'w-100'}>{question}</div>
                    <ProgressBar
                      className={styles.feedbackProgressBar}
                      style={{ minWidth: '150px' }}
                      variant={(() => {
                        switch (true) {
                          default:
                          case rating <= 2:
                            return 'danger';
                          case rating <= 3:
                            return 'warning';
                          case rating <= 5:
                            return 'success';
                        }
                      })()}
                      min={0}
                      max={5}
                      now={rating}
                      label={rating}
                    />
                  </div>
                ))}
              </div>
              {feedbacks.map((feedback) => (
                <ListGroup.Item key={feedback.id} variant={'dark'} className={'dark-list-item'}>
                  <div className={'d-flex justify-content-between'}>
                    <div>
                      Inviato da <UserUID uid={feedback.uid} customText={feedback.name} /> il{' '}
                      {formatSecondsTimestamp(feedback.created._seconds, 'dd/MM/Y HH:mm')}
                    </div>
                    <div>
                      <small>
                        <Copyable text={feedback.id} />
                      </small>
                    </div>
                  </div>
                  <div className={`mt-2 ${styles.feedbackQuestionsWrapper}`}>
                    {feedback.questions.map((q, i) => (
                      <Fragment key={i.toString()}>
                        <div className={`d-flex align-items-center ${styles.questionNumber}`}>
                          <Badge variant={'secondary'}>{i + 1}</Badge>
                        </div>
                        <div>{q}</div>
                        <div className={styles.gridConnector} />
                        <div className={'d-flex align-items-center'}>
                          <ProgressBar
                            className={`${styles.feedbackProgressBar} w-100`}
                            key={i.toString()}
                            variant={(() => {
                              switch (feedback.ratings[i]) {
                                default:
                                case 1:
                                case 2:
                                  return 'danger';
                                case 3:
                                  return 'warning';
                                case 4:
                                case 5:
                                  return 'success';
                              }
                            })()}
                            min={0}
                            max={5}
                            now={feedback.ratings[i]}
                            label={feedback.ratings[i]}
                          />
                        </div>
                      </Fragment>
                    ))}
                  </div>
                  <div className={'border-left rounded pl-2 mt-2 py-1'} style={{ backgroundColor: 'rgba(255,255,255,0.1)' }}>
                    {feedback.comment || 'Nessun commento.'}
                  </div>
                </ListGroup.Item>
              ))}
            </>
          )}
        </ListGroup>
      </Container>

      <Footer />
    </>
  );
};

export default FeedbacksComponent;
